function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M6.815.188a.69.69 0 00-.946 0l-2.364 2.26L1.14.188a.69.69 0 00-.945 0 .619.619 0 000 .903l2.837 2.712c.26.249.684.249.945 0l2.837-2.712a.62.62 0 000-.903"
});

function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    viewBox: "0 0 7 4"
  }, props), _ref);
}

export default SvgDropdown;